module.exports = __webpack_public_path__ + "static/media/feature-box-sharable.426a8d40.png";